import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import CreatableSelect from 'react-select/creatable';
import {Modal,Button, Form,Container,Row,Col,Card,Alert,Pagination,Badge,Tabs,Tab,OverlayTrigger,Tooltip
} from "react-bootstrap";
import LoadingWheel from './LoadingWheel';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/fr"; // French localization for moment
import "react-big-calendar/lib/css/react-big-calendar.css";
import Select from 'react-select';
import { PlusCircle, List, XCircle, FileText, Share2, Calendar as CalendarIcon, BarChart2, Settings,Trash2,Edit,Eye,Download} from "lucide-react";
import { addActivity } from "../../../core/store/diet/dietPan/thunk";
import { FetchActivitiesByKeyword,FetchFoodPreferencesByKeyword } from "../../../core/store/sport/categories_sport/thunk";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { motion, AnimatePresence } from "framer-motion";
import { CSVLink } from "react-csv";
import { jsPDF } from "jspdf";
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import {GetAllDietPlanByUser } from "../../../core/store/diet/dietPan/thunk";
import {PostHeightUser } from "../../../core/store/data-dashboard/thunk";
import { useNavigate } from 'react-router-dom';
// Configuration for calendar localization
moment.locale('fr');
const localizer = momentLocalizer(moment);

const ITEMS_PER_PAGE = 5;
function getMealTimeAndIcon(category = '') {
  const cat = category.toLowerCase();

  if (cat.includes('petit') || cat.includes('breakfast')) {
    return { icon: '🍳', hour: 7 };
  } else if (cat.includes('collation') || cat.includes('snack')) {
    return { icon: '🥜', hour: 10 };
  } else if (cat.includes('déjeuner') || cat.includes('lunch')) {
    return { icon: '🍽️', hour: 13 };
  } else if (cat.includes('dîner') || cat.includes('dinner') || cat.includes('souper')) {
    return { icon: '🌙', hour: 19 };
  } else {
    return { icon: '🍽️', hour: 12 };
  }
}

const AddActivityModal = ({ show, onClose, infoMessage, onSuccess }) => {
  const dispatch = useDispatch();
  
  // States
  const [showModal, setShowModal] = useState(false);
  const [activities, setActivities] = useState([]);
  const [tempActivities, setTempActivities] = useState([]);
  const [showActivities, setShowActivities] = useState(false);
  const [message, setMessage] = useState(null);
  const [activeTab, setActiveTab] = useState("activity");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [dashboardView, setDashboardView] = useState("calendar"); // 'calendar', 'stats', 'list'
  const [noPlanInfo, setNoPlanInfo] = useState("");
  const [dailyPlansApi, setDailyPlansApi] = useState([]);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showPoids, setShowPoids] = useState(false); // <-- checkbox
  const [poids, setPoids] = useState("");  
  const [canEnter, setCanEnter] = useState(true);
  const [stats, setStats] = useState({
  totalActivities: 0,
  totalMinutes: 0,
  totalMealPlans: 0,
  thisWeekActivities: 0,
  totalCalories: 0
});
const [events, setEvents] = useState([]);
   const navigate = useNavigate();

   const [selectedDate, setSelectedDate] = useState(new Date());
const [dailyPlans, setDailyPlans] = useState([]); // Structure: [{date, activities:[], preferences:[]}]


  // MODIFICATION: Ajout d'une date globale pour le plan
  const [globalDateTime, setGlobalDateTime] = useState(new Date());
  
  const [activity, setActivity] = useState({
    exercise: "",
    activityType: "sport",
    durationMinutes: "",
    dateTime: new Date(),
    preferences: "",
    intolerances: ""
  });

  // Get user data
  const authUser = sessionStorage.getItem("authUser");
  const userId = authUser ? JSON.parse(authUser)?.data?.userId : null;
  const nameUser = authUser ? JSON.parse(authUser)?.data?.firstname : null;

  // Event handlers
  // const handleClose = () => setShowModal(false);
  const handleShow = () => {
    // Reset form when opening
    setActivity({
      exercise: "",
      activityType: "sport",
      durationMinutes: "",
      dateTime: new Date(),
      preferences: "",
      intolerances: ""
    });
    setShowModal(true);
  };
  
  const handleToggleActivities = () => setShowActivities(!showActivities);
  const handleChange = (e) => setActivity({ ...activity, [e.target.name]: e.target.value });
 
  const { activitiesBD, loading } = useSelector(state => state.exerciseCategories);
  // const { activitiesBD = [], loading = false } = useSelector(state => 
  //   state.activitiesBD || { activitiesBD: [], loading: false }
  // );
  const [query, setQuery] = useState('');

  // Calculer activityOptions à partir de activitiesBD
const activityOptions = activitiesBD.map(activity => ({
  value: activity.id,
  label: activity.name
}));


  const handleInputChange = (inputValue) => {
    setQuery(inputValue);
    if (inputValue.length >= 1) {
      dispatch(FetchActivitiesByKeyword(inputValue));
    }
  };

  useEffect(() => {
   // dispatch(FetchActivitiesByKeyword(""));
    console.log("Redux state for activities:", activities);
  }, [activities]);


  const { foodPreferences = [], loadingPreferences = false } = useSelector(state =>
  state.foodPreferences || { foodPreferences: [], loadingPreferences: false }
);
const [foodQuery, setFoodQuery] = useState('');

const foodPreferencesOptions = useMemo(() => {
  return foodPreferences.map(pref => ({
    label: pref.description, // Ajustez selon la structure de vos données
    value: pref.description
  }));
}, [foodPreferences]);

const handleFoodInputChange = (inputValue) => {
  setFoodQuery(inputValue);
  if (inputValue.length >= 1) {
    dispatch(FetchFoodPreferencesByKeyword(inputValue));
  }
};

  useEffect(() => {
    const lastDate = localStorage.getItem("lastWeightDate");
    // Clear messages after 5 seconds
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, 5000);
      
      return () => clearTimeout(timer);
    }

    if (lastDate) {
      const diffDays =
        (new Date() - new Date(lastDate)) / (1000 * 60 * 60 * 24);
      if (diffDays < 3) {
        setCanEnter(false); // pas encore 3 jours
      }
    }
  }, [message, userId]);

 const [isMobile, setIsMobile] = useState(false);

 
  // Détection du mobile avec useEffect et MediaQuery
  useEffect(() => {
  const userId = JSON.parse(sessionStorage.getItem('authUser'))?.data?.userId;
  if (!userId) {
    console.error('User ID not found in sessionStorage');
    return;
  }

  const todayDate = moment().format("YYYY-MM-DD");

  const handleResponse = (apiResponse) => {
    const plans = apiResponse?.data || [];

    // 🔍 Trouver le plan du jour
    let foundMealPlan = plans.find(plan =>
      plan.dailyPlans?.some(p => moment(p.dailyDate).format("YYYY-MM-DD") === todayDate)
    );
    const foundPlan = foundMealPlan?.dailyPlans?.find(p =>
      moment(p.dailyDate).format("YYYY-MM-DD") === todayDate
    );

    // 📅 Générer les événements pour le calendrier
    const events = plans.flatMap(plan =>
      plan.dailyPlans?.flatMap(daily => {
        const date = daily.dailyDate;

        const meals = daily.dailyMeals?.map(meal => {
          if (!meal.recipe) return null;
          const { icon, hour } = getMealTimeAndIcon(meal.recipe.category);
          const start = new Date(`${date}T${String(hour).padStart(2, '0')}:00:00`);
          const end = new Date(start.getTime() + 1.5 * 60 * 60 * 1000); // +2h
          return {
            title: `${icon} ${meal.recipe.recipeName}`,
            start,
            end,
            allDay: false,
            type: 'meal'
          };
        }) || [];

        const activities = daily.activities?.map(act => ({
  title: act.activity.name,
  start: new Date(date),
  end: new Date(date),
  allDay: true, 
  type: 'activity',
  duration: act.duration || 30,
  // Ajout de métadonnées pour un meilleur affichage
  resource: {
    icon: '💼🏃‍♂️',
    category: 'Activité physique'
  }
})) || [];




        return [...meals.filter(Boolean), ...activities];
      }) || []
    );
    setEvents(events);

    // 📊 Gestion des statistiques
    if (!foundPlan) {
      setNoPlanInfo("Aucun programme nutritionnel n'est disponible pour aujourd'hui. Veuillez en générer un afin de poursuivre.");
      setShowInfoModal(true);
      resetStats();
      return;
    }

    const mealPlan = foundMealPlan;

    const newStats = {
      totalActivities: mealPlan.user?.activities?.length || 0,
      totalMinutes: calculateTotalMinutes(mealPlan.user?.activities || []),
      totalMealPlans: mealPlan.dailyPlans?.reduce((acc, plan) => acc + (plan.dailyMeals?.length || 0), 0),
      thisWeekActivities: calculateThisWeekPlans(mealPlan.dailyPlans || []),
      totalCalories: mealPlan.totalCalories || 0
    };
    setStats(newStats);

    // 🗒️ Liste des activités (repas + physiques)
    const formattedActivities = [];

    mealPlan.dailyPlans?.forEach(plan => {
      plan.dailyMeals?.forEach(meal => {
        formattedActivities.push({
          name: meal.recipe?.name || "Repas",
          dateTime: plan.dailyDate,
          durationMinutes: 30,
          type: "meal",
          consumed: meal.consumed,
          preferences: meal.recipe?.description || ""
        });
      });
    });

    mealPlan.user?.activities?.forEach(activity => {
      formattedActivities.push({
        name: activity.name,
        dateTime: new Date().toISOString(),
        durationMinutes: Math.round(activity.met * 15),
        type: "physical",
        exercise: activity.name
      });
    });

    // setActivities(formattedActivities); // Décommente si tu veux l'afficher ailleurs
  };
  dispatch(GetAllDietPlanByUser(userId))
    .then((result) => {
      console.log('Succès:', result.payload);
      if (result.payload?.code === 200) {
        handleResponse(result.payload);
      } else {
        setNoPlanInfo("Aucune donnée reçue du serveur.");
        setShowInfoModal(true);
        resetStats();
      }
    })
    .catch((error) => {
      console.error('Erreur:', error);
      resetStats();
    });

  // 📱 Responsive check
  const checkIfMobile = () => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    setIsMobile(mediaQuery.matches);
  };

  checkIfMobile();

  const mediaQuery = window.matchMedia('(max-width: 768px)');
  const handler = (e) => setIsMobile(e.matches);

  mediaQuery.addEventListener ? mediaQuery.addEventListener('change', handler)
                              : mediaQuery.addListener(handler);

  return () => {
    mediaQuery.removeEventListener ? mediaQuery.removeEventListener('change', handler)
                                   : mediaQuery.removeListener(handler);
  };

}, [dispatch]);



const handleSavePoids = () => {
  if (poids) {
    dispatch(PostHeightUser(poids))
      .unwrap()
      .then(() => {
        localStorage.setItem("lastWeightDate", new Date().toISOString()); // ✅ on sauvegarde la date
        setPoids("");
        setShowPoids(false);
        setCanEnter(false); // bloque l'entrée pour 3 jours
      })
      .catch((err) => {
        console.error("Erreur enregistrement poids:", err);
      });
  }
};

// 🔧 Utilitaires
function calculateTotalMinutes(activities) {
  return activities.reduce((total, activity) => total + Math.round(activity.met * 15), 0);
}

function calculateThisWeekPlans(dailyPlans) {
  const today = new Date();
  const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
  const endOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 6));
  return dailyPlans.filter(plan => {
    const planDate = new Date(plan.dailyDate);
    return planDate >= startOfWeek && planDate <= endOfWeek;
  }).length;
}

function resetStats() {
  setStats({
    totalActivities: 0,
    totalMinutes: 0,
    totalMealPlans: 0,
    thisWeekActivities: 0,
    totalCalories: 0
  });
}




 

  // Prepare events for calendar
  // const events = activities.map((act, index) => ({
  //   id: act.id || index,
  //   title: act.name || act.exercise || (act.preferences ? "Repas planifié" : "Activité"),
  //   start: new Date(act.dateTime),
  //   end: moment(act.dateTime).add(act.durationMinutes || act.durer || 60, "minutes").toDate(),
  //   allDay: false,
  //   resource: act.preferences ? "meal" : "activity"
  // }));

  // Search function
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };



// Version corrigée de handleEditDailyPlan
const handleEditDailyPlan = (planToEdit) => {
  try {
    // Parse et configure la date
    let dateToEdit;
        
    if (typeof planToEdit.date === 'string') {
      dateToEdit = new Date(planToEdit.date);
      if (!isNaN(dateToEdit.getTime())) {
        dateToEdit = new Date(dateToEdit.getFullYear(), dateToEdit.getMonth(), dateToEdit.getDate(), 12, 0, 0);
      }
    } else if (planToEdit.date instanceof Date) {
      const origDate = new Date(planToEdit.date);
      dateToEdit = new Date(origDate.getFullYear(), origDate.getMonth(), origDate.getDate(), 12, 0, 0);
    } else {
      const now = new Date();
      dateToEdit = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
    }
        
    if (isNaN(dateToEdit.getTime())) {
      console.error("Date invalide:", planToEdit.date);
      const now = new Date();
      dateToEdit = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
    }
        
    console.log("=== ÉDITION DU PLAN ===");
    console.log("Plan à éditer:", planToEdit);
    console.log("Date configurée:", dateToEdit);
        
    // *** CORRECTION PRINCIPALE : Charger les données du plan dans currentDayPlans ***
    setCurrentDayPlans([{
      date: dateToEdit.toDateString(),
      activities: planToEdit.activities || [],
      preferences: planToEdit.preferences || []
    }]);
        
    // Définir la date sélectionnée
    setSelectedDate(dateToEdit);
        
    // Réinitialiser le formulaire (garder vide pour permettre l'ajout de nouveaux éléments)
    setActivity({
      exercise: '',
      activityType: 'sport',
      durationMinutes: '',
      dateTime: dateToEdit,
      preferences: '',
      intolerances: ''
    });
        
    // Définir l'onglet actif selon le contenu existant
    if (planToEdit.activities && planToEdit.activities.length > 0) {
      setActiveTab("activity");
    } else if (planToEdit.preferences && planToEdit.preferences.length > 0) {
      setActiveTab("meal");
    } else {
      setActiveTab("activity");
    }
        
    // Ouvrir le modal
    setShowModal(true);
        
    toast.info(`Édition du plan du ${dateToEdit.toLocaleDateString()}`, {
      position: "top-right",
      autoClose: 3000
    });
      
  } catch (error) {
    console.error("Erreur lors de l'édition du plan:", error);
    toast.error("Erreur lors de l'ouverture du plan à éditer");
  }
};

// *** CORRECTION SUPPLÉMENTAIRE : Améliorer handleAddDayPlan pour la mise à jour ***
const handleAddDayPlan = () => {
  const currentPlan = getCurrentDayPlan();
    
  if (currentPlan.activities.length === 0 && currentPlan.preferences.length === 0) {
    toast.warning("Ajoutez au moins une activité ou préférence pour cette journée", {
      position: "top-center"
    });
    return;
  }

  // Vérifier si un plan existe déjà pour cette date dans dailyPlans
  const dateStr = selectedDate.toDateString();
  const existingIndex = dailyPlans.findIndex(plan => plan.date === dateStr);
    
  if (existingIndex >= 0) {
    // Mettre à jour le plan existant
    const newPlans = [...dailyPlans];
    newPlans[existingIndex] = {
      ...currentPlan,
      date: dateStr // S'assurer que la date est correcte
    };
    setDailyPlans(newPlans);
    toast.success(`Plan du ${selectedDate.toLocaleDateString()} mis à jour`, {
      position: "top-right",
      autoClose: 2000
    });
  } else {
    // Ajouter nouveau plan
    const newPlan = {
      ...currentPlan,
      date: dateStr
    };
    setDailyPlans([...dailyPlans, newPlan]);
    toast.success(`Plan journalier du ${selectedDate.toLocaleDateString()} ajouté`, {
      position: "top-right",
      autoClose: 2000
    });
  }
    
  // Fermer la modal et nettoyer
  handleClose();
};



// Fonction pour supprimer une activité d'un jour spécifique
const handleRemoveActivity = (activityId) => {
  const currentPlan = getCurrentDayPlan();
  const updatedPlan = {
    ...currentPlan,
    activities: currentPlan.activities.filter(act => act.id !== activityId)
  };
  updateDayPlan(updatedPlan);
  
  toast.info("Activité supprimée", {
    position: "top-right",
    autoClose: 2000
  });
};

// Fonction pour supprimer une préférence d'un jour spécifique
const handleRemovePreference = (preferenceId) => {
  const currentPlan = getCurrentDayPlan();
  const updatedPlan = {
    ...currentPlan,
    preferences: currentPlan.preferences.filter(pref => pref.id !== preferenceId)
  };
  updateDayPlan(updatedPlan);
  
  toast.info("Préférence supprimée", {
    position: "top-right",
    autoClose: 2000
  });
};

// Fonction finale pour générer le plan complet
const handleGenerateFullPlan = async () => {
  if (!dailyPlans.length) {
    toast.warning("Ajoutez au moins une activité ou préférence pour une date avant de générer", {
      position: "top-center"
    });
    return;
  }
  
  setIsGenerating(true);

  try {
    // Préparer le payload selon le format demandé
    const payloadToBackend = dailyPlans.map(plan => ({
      date: plan.date,
      activities: plan.activities.map(act => ({
        name: act.name,
        duration: act.duration,
        met: act.met
      })),
      preferences: plan.preferences.map(pref => ({
        type: pref.type,
        name: pref.name
      }))
    }));

    console.log("Payload final envoyé au backend:", payloadToBackend);
    
    // Simulation du délai
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Dispatch vers le backend
    await dispatch(addActivity({ userId, activity: payloadToBackend })).unwrap();

    // Nettoyer les plans temporaires
    setDailyPlans([]);
    
    if (onSuccess) onSuccess();
    
    toast.success("Plan multi-jours généré avec succès!", {
      position: "top-right",
      autoClose: 3000
    });
    
    setTimeout(() => {
      navigate('/dailyPlan');
    }, 1500);
    
  } catch (error) {
    console.error("Erreur lors de la génération:", error);
    if (onSuccess) onSuccess();
    toast.error("Erreur lors de la génération du plan", {
      position: "top-right"
    });
  } finally {
    setIsGenerating(false);
  }
};






// 1. MODIFICATION du handleSubmit pour créer des plans journaliers
const handleSubmit = (e) => {
  e.preventDefault();
  setIsLoading(true);

  let isFormValid = true;

  // Validation activité
  if (activeTab === "activity") {
    const activityRequiredFields = ["exercise", "durationMinutes"];
    isFormValid = activityRequiredFields.every((field) => activity[field]);

    if (!isFormValid) {
      setMessage({ 
        type: "danger", 
        text: "Veuillez remplir tous les champs requis pour l'activité." 
      });
      setIsLoading(false);
      return;
    }
  } 
  // Validation alimentaire
  else if (activeTab === "meal") {
    isFormValid = activity.preferences || activity.intolerances;

    if (!isFormValid) {
      setMessage({ 
        type: "danger", 
        text: "Veuillez indiquer au moins une préférence ou intolérance alimentaire." 
      });
      setIsLoading(false);
      return;
    }
  }

  // ➕ Création de l’élément à ajouter
  let newItem;
  if (activeTab === "activity") {
    const selectedActivity = activityOptions.find(opt => opt.value === activity.exercise);

    newItem = {
      id: Date.now(),
      exercise: activity.exercise, // ID
      exerciseName: selectedActivity?.label || "Inconnu", // ✅ Nom
      duration: parseInt(activity.durationMinutes),
      met: selectedActivity?.met || 1
    };
  } else {
    // ➕ Préférences / Intolérances
    const preferences = [];

    if (activity.preferences) {
      preferences.push({
        id: Date.now(),
        type: "ALIMENTARY",
        name: activity.preferences
      });
    }

    if (activity.intolerances) {
      const intolerances = activity.intolerances.split(',').map(item => ({
        id: Date.now() + Math.random(),
        type: "INTOLERANCE", 
        name: item.trim()
      }));
      preferences.push(...intolerances);
    }

    newItem = preferences;
  }

  // 🗓️ Mise à jour du plan du jour
  const dateStr = selectedDate.toDateString();
  const currentPlan = getCurrentDayPlan();

  let updatedPlan;
  if (activeTab === "activity") {
    updatedPlan = {
      ...currentPlan,
      date: dateStr,
      activities: [...currentPlan.activities, newItem]
    };
  } else {
    updatedPlan = {
      ...currentPlan,
      date: dateStr,
      preferences: [...currentPlan.preferences, ...newItem]
    };
  }

  updateDayPlan(updatedPlan);

  // 🧼 Réinitialisation
  setActivity({
    exercise: "",
    activityType: "sport", 
    durationMinutes: "",
    dateTime: new Date(),
    preferences: "",
    intolerances: ""
  });

  toast.success(activeTab === "activity" 
    ? "Activité ajoutée au plan du jour" 
    : "Préférence alimentaire ajoutée au plan du jour", 
    { position: "top-right", autoClose: 2000 }
  );

  setIsLoading(false);
};


// 3. MODIFICATION du getCurrentDayPlan pour gérer les plans temporaires dans la modal
const getCurrentDayPlan = () => {
  const dateStr = selectedDate.toDateString();
  
  // D'abord chercher dans les plans temporaires de la modal
  const tempPlan = currentDayPlans.find(plan => plan.date === dateStr);
  if (tempPlan) return tempPlan;
  
  // Sinon retourner un plan vide
  return {
    date: dateStr,
    activities: [],
    preferences: []
  };
};

// 4. NOUVEAU state pour gérer les plans temporaires de la modal
const [currentDayPlans, setCurrentDayPlans] = useState([]); // Plans en cours de création dans la modal

// 5. MODIFICATION de updateDayPlan pour les plans temporaires
const updateDayPlan = (updatedPlan) => {
  const dateStr = selectedDate.toDateString();
  const existingIndex = currentDayPlans.findIndex(plan => plan.date === dateStr);
  
  if (existingIndex >= 0) {
    const newPlans = [...currentDayPlans];
    newPlans[existingIndex] = updatedPlan;
    setCurrentDayPlans(newPlans);
  } else {
    setCurrentDayPlans([...currentDayPlans, updatedPlan]);
  }
};

// 6. MODIFICATION de handleClose pour réinitialiser les plans temporaires
const handleClose = () => {
  setShowModal(false);
  setCurrentDayPlans([]); // Reset des plans temporaires de la modal
  setActivity({
    exercise: "",
    activityType: "sport",
    durationMinutes: "",
    dateTime: new Date(),
    preferences: "",
    intolerances: ""
  });
};

// 7. NOUVELLE fonction pour générer le programme multi-journalier
const handleGenerateMultiDayPlan = async () => {
  if (!dailyPlans.length) {
    toast.warning("Ajoutez au moins un plan journalier avant de générer", {
      position: "top-center"
    });
    return;
  }
  
  setIsGenerating(true);

  try {
    // Préparer le payload selon le format backend requis
    const payloadToBackend = {
  activities: dailyPlans.map(plan => ({
    date: moment(plan.date).format('YYYY-MM-DD'),
     activities: plan.activities.map(act => ({
        name: act.exerciseName,
        duration: act.duration,
      })),
      suPreference: plan.preferences.map(pref => ({
      type: pref.type,
      name: pref.name
    }))
  }))
};


    console.log("Payload multi-journalier envoyé au backend:", payloadToBackend);
    
    // Simulation du délai
    //await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Dispatch vers le backend
    await dispatch(addActivity({ userId, activity: payloadToBackend })).unwrap();

    // Nettoyer les plans
    setDailyPlans([]);
    
    if (onSuccess) onSuccess();
    
    toast.success("Programme multi-journalier généré avec succès!", {
      position: "top-right",
      autoClose: 3000
    });
    
    setTimeout(() => {
      navigate('/dailyPlan');
    }, 1500);
    
  } catch (error) {
    console.error("Erreur lors de la génération:", error);
    if (onSuccess) onSuccess();
    toast.error("Erreur lors de la génération du programme", {
      position: "top-right"
    });
  } finally {
    setIsGenerating(false);
  }
};




  // Filter activities by search term
  const filteredActivities = activities.filter(act => {
    const searchValue = searchTerm.toLowerCase();
    return (
      (act.name?.toLowerCase().includes(searchValue)) ||
      (act.exercise?.toLowerCase().includes(searchValue)) ||
      (act.preferences?.toLowerCase().includes(searchValue)) ||
      (act.intolerances?.toLowerCase().includes(searchValue)) ||
      (act.durationMinutes?.toString().includes(searchValue)) ||
      (act.durer?.toString().includes(searchValue))
    );
  });


  // Pagination
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = filteredActivities.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredActivities.length / ITEMS_PER_PAGE);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // PDF Export
  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Programme d'Activités et Nutrition", 14, 20);
    doc.setFontSize(12);
    doc.text("Généré le " + new Date().toLocaleDateString('fr-FR'), 14, 30);
    
    let yPos = 40;
    
    // Display activities
    if (activities.filter(a => !a.preferences).length > 0) {
      doc.setFontSize(14);
      doc.text("Activités physiques", 14, yPos);
      yPos += 10;
      
      activities.filter(a => !a.preferences).forEach((act, index) => {
        doc.setFontSize(11);
        const date = new Date(act.dateTime).toLocaleDateString('fr-FR');
        const time = new Date(act.dateTime).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
        
        doc.text(`${index + 1}. ${act.name || act.exercise} - ${act.durationMinutes || act.durer} minutes`, 14, yPos);
        doc.text(`   Date: ${date} à ${time}`, 14, yPos + 5);
        
        yPos += 15;
        
        // New page if needed
        if (yPos > 270) {
          doc.addPage();
          yPos = 20;
        }
      });
    }
    
    // Display food preferences
    if (activities.filter(a => a.preferences).length > 0) {
      doc.setFontSize(14);
      doc.text("Préférences alimentaires", 14, yPos);
      yPos += 10;
      
      activities.filter(a => a.preferences).forEach((meal, index) => {
        doc.setFontSize(11);
        const date = new Date(meal.dateTime).toLocaleDateString('fr-FR');
        
        doc.text(`${index + 1}. Plan du ${date}`, 14, yPos);
        if (meal.preferences) {
          doc.text(`   Préférences: ${meal.preferences}`, 14, yPos + 5);
          yPos += 5;
        }
        if (meal.intolerances) {
          doc.text(`   Intolérances: ${meal.intolerances}`, 14, yPos + 5);
          yPos += 5;
        }
        
        yPos += 10;
        
        // New page if needed
        if (yPos > 270) {
          doc.addPage();
          yPos = 20;
        }
      });
    }
    
    doc.save("programme-activites-nutrition.pdf");
    
    toast.success("PDF exporté avec succès", {
      position: "bottom-right",
      autoClose: 2000
    });
  };


  // Stats for dashboard
  // const stats = {
  //   totalActivities: activities.filter(a => !a.preferences).length,
  //   totalMinutes: activities.reduce((sum, act) => sum + (parseInt(act.durationMinutes) || parseInt(act.durer) || 0), 0),
  //   totalMealPlans: activities.filter(a => a.preferences).length,
  //   thisWeekActivities: activities.filter(a => {
  //     const actDate = new Date(a.dateTime);
  //     const startOfWeek = moment().startOf('week').toDate();
  //     const endOfWeek = moment().endOf('week').toDate();
  //     return actDate >= startOfWeek && actDate <= endOfWeek && !a.preferences;
  //   }).length
  // };
  return (
    <Container fluid className="py-3">
      {/* Notifications */}
      <ToastContainer />
<Modal show={showInfoModal} onHide={() => setShowInfoModal(false)} centered>
  <Modal.Header closeButton className="bg-warning-subtle">
    <Modal.Title className="text-warning">
      ⚠️ Programme non disponible
    </Modal.Title>
  </Modal.Header>
  <Modal.Body className="text-center py-4">
    <p className="mb-3 fs-5 text-muted">
      {noPlanInfo || "Aucun programme nutritionnel n'est disponible pour aujourd'hui."}
    </p>
    <p className="text-muted small">
      Vous devez d'abord générer un plan pour continuer votre suivi nutritionnel.
    </p>
  </Modal.Body>
  <Modal.Footer className="d-flex justify-content-center">
    <Button variant="primary" onClick={() => {
      setShowInfoModal(false);
    }}>
      ok
    </Button>
  </Modal.Footer>
</Modal>




<Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Ajouter une activité</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {infoMessage && <div className="alert alert-info">{infoMessage}</div>}
        {/* Formulaire ici */}
      </Modal.Body>
    </Modal>

      <Row className="mb-3 align-items-center">
        <Col>
          <h2 className="mb-0 fs-4 fs-md-3 fs-lg-2" style={{ color: "#2c3e50" }}>
            <CalendarIcon className="me-2" size={window.innerWidth < 768 ? 20 : 28} color="#3498db" />
            <span className="d-none d-sm-inline">Planification d'</span>Activités et Nutrition
          </h2>
        </Col>
      </Row>
  
      {/* Confirmation or error message */}
      <AnimatePresence>
        {message && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
          >
            <Alert variant={message.type} dismissible onClose={() => setMessage(null)}>
              {message.text}
            </Alert>
          </motion.div>
        )}
      </AnimatePresence>
  
      {/* Toolbar */}
      <Row className="mb-3">
        <Col lg={8} md={7} className="d-flex flex-wrap gap-2 mb-2 mb-md-0">
          <Button
            variant="success"
            onClick={handleShow}
            className="d-flex align-items-center shadow-sm"
            style={{ backgroundColor: "#27ae60", borderColor: "#219653" }}
          >
            <PlusCircle size={16} className="me-1 me-sm-2" />
            <span className="d-none d-sm-inline">Programmer</span>
            <span className="d-inline d-sm-none">+</span>
          </Button>
          
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Afficher/Masquer la liste des activités</Tooltip>}
          >
            <Button
              variant={showActivities ? "info" : "outline-info"}
              onClick={() => {
                setDashboardView("listeAct");
                handleToggleActivities();
              }}
              className="d-flex align-items-center shadow-sm"
              style={showActivities ? { backgroundColor: "#34495e", borderColor: "#2471a3" } : {}}
            >
              {showActivities && dashboardView === 'listeAct' ? <XCircle size={16} className="me-1 me-sm-2" /> : <List size={16} className="me-1 me-sm-2" />}
              <span className="d-none d-sm-inline">{showActivities && dashboardView === 'listeAct' ? "Masquer la liste" : "Liste des activités"}</span>
              <span className="d-inline d-sm-none">{showActivities && dashboardView === 'listeAct' ? "X" : "Liste"}</span>
            </Button>
          </OverlayTrigger>
          
          <Button
            variant="outline-primary"
            onClick={() => setDashboardView("calendar")}
            className={`d-flex align-items-center shadow-sm ${dashboardView === 'calendar' ? 'active' : ''}`}
            style={dashboardView === 'calendar' ? { backgroundColor: "#e8f4fc", borderColor: "#3498db", color: "#2980b9" } : {}}
          >
            <CalendarIcon size={16} className="me-1 me-sm-2" />
            <span className="d-none d-sm-inline">Calendrier</span>
            <span className="d-inline d-sm-none">Cal</span>
          </Button>
          
          <Button
            variant="outline-primary"
            onClick={() => setDashboardView("stats")}
            className={`d-flex align-items-center shadow-sm ${dashboardView === 'stats' ? 'active' : ''}`}
            style={dashboardView === 'stats' ? { backgroundColor: "#eafaf1", borderColor: "#2ecc71", color: "#27ae60" } : {}}
          >
            <BarChart2 size={16} className="me-1 me-sm-2" />
            <span className="d-none d-sm-inline">Statistiques</span>
            <span className="d-inline d-sm-none">Stats</span>
          </Button>
        </Col>
        
        <Col lg={4} md={5}>
          <Row>
            <Col xs={8}>
              <Form.Control
                type="text"
                placeholder="Rechercher..."
                value={searchTerm}
                onChange={handleSearch}
                className="shadow-sm"
                style={{ borderColor: "#bdc3c7" }}
              />
            </Col>
            <Col xs={4}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Exporter en PDF</Tooltip>}
              >
                <Button
                  variant="outline-danger"
                  onClick={exportToPDF}
                  className="w-100 d-flex align-items-center justify-content-center shadow-sm"
                  style={{ borderColor: "#e74c3c", color: "#c0392b" }}
                >
                  <Download size={16} className="me-1 me-sm-2" />
                  <span className="d-none d-sm-inline">PDF</span>
                </Button>
              </OverlayTrigger>
            </Col>
          </Row>
        </Col>
      </Row>
  
      {/* Main dashboard */}
      <Card className="shadow-sm mb-4" style={{ backgroundColor: "#f5f7fa", borderColor: "#dfe4ea" }}>
        <Card.Header className="py-2 py-md-3" 
          style={{  
            backgroundColor: dashboardView === "calendar" ? "#2980b9" : 
                             dashboardView === "stats" ? "#27ae60" : 
                             dashboardView === "listeAct" ? "#34495e" :"#34495e", 
            color: "white",
            transition: "background-color 0.3s ease" 
          }}
        >
          <Row className="align-items-center">
            <Col>
              <h5 className="mb-0 fs-6 fs-md-5 d-flex align-items-center">
                {dashboardView === "calendar" && <CalendarIcon size={18} className="me-2" />}
                {dashboardView === "stats" && <BarChart2 size={18} className="me-2" />}
                {!dashboardView && <List size={18} className="me-2" />}
                {dashboardView === "calendar" ? "Calendrier des Activités" : 
                 dashboardView === "stats" ? "Statistiques d'Activités" : "Tableau de bord"}
              </h5>
            </Col>
            <Col xs="auto">
              <Badge bg="light" text="dark" className="me-1 me-sm-2">
                {stats.totalActivities} <span className="d-none d-sm-inline">activités</span>
              </Badge>
              <Badge bg="light" text="dark">
                {stats.totalMinutes} <span className="d-none d-sm-inline">minutes</span>
              </Badge>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body style={{ backgroundColor: "#f5f7fa" }}>
          <Row>
            {/* First part: Calendar or Stats */}
            <Col lg={showActivities ? 5 : 7} md={showActivities ? 5 : 7 } sm={12 } className="mb-4">
              {dashboardView === "calendar" ? (
                <>
                  <h5 className="text-center mb-3" style={{ color: "#2980b9" }}>
                    <CalendarIcon size={16} className="me-2" />
                    Agenda des Activités et preferences Programmer
                  </h5>
                  <div className="calendar-container" style={{ 
                    backgroundColor: "#ffffff", 
                    padding: "10px", 
                    borderRadius: "8px", 
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    border: "1px solid #e6f2fa",
                    height: window.innerWidth < 768 ? "400px" : "550px"
                  }}>
                    <Calendar
                          localizer={localizer}
                          events={events}
                          startAccessor="start"
                          endAccessor="end"
                          style={{ height: "100%" }}
                          views={isMobile ? ['month'] : ['month', 'week', 'day']}
                          messages={{
                            today: "Aujourd'hui",
                            previous: "Précédent",
                            next: "Suivant",
                            month: "Mois",
                            week: "Semaine",
                            day: "Jour",
                            noEventsInRange: "Aucun événement dans cette période"
                          }}
                          eventPropGetter={(event) => {
                            let style = {
                              backgroundColor: '#e3f2fd', 
                              color: '#0d47a1',
                              borderRadius: '8px',
                              padding: '4px 8px',
                              border: 'none',
                              fontSize: '16px',
                              fontWeight: '500',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              transition: 'all 0.2s ease'
                            };

                            // Style pour les repas
                            if (event.type === 'meal') {
                              style.backgroundColor = '#e8f5e9'; 
                              style.color = '#2e7d32';
                              style.borderLeft = '4px solid #4caf50';
                            }

                            // Style pour les activités - correction de la couleur
                           if (event.type === 'activity') {
                              style.backgroundColor = '#d6eaf8';         
                              style.borderLeft = '4px solid #2980b9';   
                              style.color = '#154360';                 
                            }


                            // Style pour les autres types d'événements
                            if (event.type === 'appointment') {
                              style.backgroundColor = '#fff3e0';
                              style.color = '#e65100';
                              style.borderLeft = '4px solid #ff9800';
                            }

                            return { style };
                          }}
                          // Personnalisation de l'affichage des événements
                          components={{
                            event: ({ event }) => (
                              <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '4px',
                                overflow: 'hidden'
                              }}>
                                {event.resource?.icon && (
                                  <span style={{ fontSize: '14px' }}>
                                    {event.resource.icon}
                                  </span>
                                )}
                                <span style={{ 
                                  flex: 1, 
                                  overflow: 'hidden', 
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}>
                                  {event?.title}
                                </span>
                                {event.duration && (
                                  <span style={{ 
                                    fontSize: '10px', 
                                    opacity: 0.8,
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    padding: '1px 4px',
                                    borderRadius: '10px'
                                  }}>
                                    {event.duration}min
                                  </span>
                                )}
                              </div>
                            )
                          }}
                          // Amélioration des tooltips
                          popup
                          popupOffset={30}
                        />

                  </div>
                </>
              ) : (
                <div className="statistics-container p-2 p-md-3" style={{ 
                  backgroundColor: "#ffffff", 
                  borderRadius: "8px", 
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  border: "1px solid #ebf7f2",
                  height: window.innerWidth < 768 ? "400px" : "590px"
                }}>
                  <h5 className="text-center mb-3 mb-md-4" style={{ color: "#27ae60" }}>
                    <BarChart2 size={16} className="me-2" />
                    Statistiques d'Activités
                  </h5>
                  
                  <Row className="stats-row text-center">
                    <Col xs={6} md={3} className="mb-3">
                      <Card className="h-100 shadow-sm border-0" style={{ backgroundColor: "#f8f9fa", borderLeft: "4px solid #3498db" }}>
                        <Card.Body className="d-flex flex-column align-items-center justify-content-center p-2 p-md-3">
                          <div className="stats-icon mb-1 mb-md-2 p-1 p-md-2 rounded-circle" style={{ backgroundColor: "#ebf5fb" }}>
                            <i className="bi bi-lightning-fill fs-5" style={{ color: "#3498db" }}></i>
                          </div>
                          <h3 className="mb-0 fs-4 fs-md-3">{stats.totalActivities}</h3>
                          <p className="text-muted small mb-0">Activités</p>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={6} md={3} className="mb-3">
                      <Card className="h-100 shadow-sm border-0" style={{ backgroundColor: "#f8f9fa", borderLeft: "4px solid #27ae60" }}>
                        <Card.Body className="d-flex flex-column align-items-center justify-content-center p-2 p-md-3">
                          <div className="stats-icon mb-1 mb-md-2 p-1 p-md-2 rounded-circle" style={{ backgroundColor: "#e9f7ef" }}>
                            <i className="bi bi-clock-fill fs-5" style={{ color: "#27ae60" }}></i>
                          </div>
                          <h3 className="mb-0 fs-4 fs-md-3">{stats.totalMinutes}</h3>
                          <p className="text-muted small mb-0">Minutes</p>
                        </Card.Body>
                      </Card>
                    </Col>
                    
                    <Col xs={6} md={3} className="mb-3">
                      <Card className="h-100 shadow-sm border-0" style={{ backgroundColor: "#f8f9fa", borderLeft: "4px solid #e67e22" }}>
                        <Card.Body className="d-flex flex-column align-items-center justify-content-center p-2 p-md-3">
                          <div className="stats-icon mb-1 mb-md-2 p-1 p-md-2 rounded-circle" style={{ backgroundColor: "#fef5e7" }}>
                            <i className="bi bi-egg-fried fs-5" style={{ color: "#e67e22" }}></i>
                          </div>
                          <h3 className="mb-0 fs-4 fs-md-3">{stats.totalMealPlans}</h3>
                          <p className="text-muted small mb-0">Repas</p>
                        </Card.Body>
                      </Card>
                    </Col>
                    
                    <Col xs={6} md={3} className="mb-3">
                      <Card className="h-100 shadow-sm border-0" style={{ backgroundColor: "#f8f9fa", borderLeft: "4px solid #8e44ad" }}>
                        <Card.Body className="d-flex flex-column align-items-center justify-content-center p-2 p-md-3">
                          <div className="stats-icon mb-1 mb-md-2 p-1 p-md-2 rounded-circle" style={{ backgroundColor: "#fdf2f2" }}>
                            <i className="bi bi-fire fs-5" style={{ color: "#e74c3c" }}></i>
                          </div>
                          <h3 className="mb-0 fs-4 fs-md-3">{stats.totalCalories}</h3>
                          <p className="text-muted small mb-0">Calories</p>
                        </Card.Body>
                                          </Card>
                    </Col>
                  </Row>
                  
                 
                  {/* <Row className="mt-3 mt-md-4">
                    <Col md={12}>
                      <Card className="shadow-sm" style={{ backgroundColor: "#ffffff", borderColor: "#ebf7f2" }}>
                        <Card.Body className="p-2 p-md-3">
                          <h6 className="mb-2 mb-md-3" style={{ color: "#27ae60" }}>Répartition par type d'activité</h6>
                          <div className="chart-placeholder p-3 text-center rounded" style={{ backgroundColor: "#f8f9fa", border: "1px dashed #dfe4ea", height: window.innerWidth < 768 ? "100px" : "150px" }}>
                            <p className="mb-0 text-muted small">Graphique de répartition des activités</p>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row> */}
                </div>
              )}
            </Col>
  
            {/* Central part: Date selection and temporary activities */}
          

<Col lg={showActivities ? 4 : 5} md={showActivities ? 4 : 5} sm={12} className="ps-md-4 ps-lg-4 mb-4">
  <Card className="mb-4 shadow-sm" style={{ backgroundColor: "#ffffff", borderColor: "#dfe4ea" }}>
    <Card.Body className="p-2 p-md-3">
      <h5 className="text-center fw-bold border-bottom pb-2 mb-3" style={{ color: "#2c3e50", borderColor: "#dfe4ea", fontSize: window.innerWidth < 768 ? "1rem" : "1.25rem" }}>
        Programmes journaliers planifiés
      </h5>
      
      {/* Affichage des plans journaliers */}
      {dailyPlans.length > 0 ? (
        <div className="mb-3">
          <div className="alert text-center py-2" style={{ 
            backgroundColor: "#e8f5e8", 
            borderLeft: "4px solid #27ae60", 
            color: "#2d5a2d",
            fontSize: window.innerWidth < 768 ? "0.8rem" : "0.9rem"
          }}>
            <i className="bi bi-check-circle-fill me-2"></i>
            {dailyPlans.length} jour{dailyPlans.length > 1 ? 's' : ''} planifié{dailyPlans.length > 1 ? 's' : ''}
          </div>
          
          <div className="daily-plans-preview" style={{ maxHeight: "200px", overflowY: "auto" }}>
            {dailyPlans.map((plan, index) => (
              <div key={index} className="card mb-2" style={{ fontSize: window.innerWidth < 768 ? "0.8rem" : "0.9rem" }}>
                <div className="card-body p-2">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <strong>{new Date(plan.date).toLocaleDateString()}</strong>
                    <div className="d-flex gap-1">
                      <Button 
                        variant="outline-primary" 
                        size="sm" 
                        onClick={() => handleEditDailyPlan(plan)}
                        className="p-1"
                        title="Modifier ce plan"
                      >
                        <i className="bi bi-pencil" style={{ fontSize: "12px" }}></i>
                      </Button>
                      <Button 
                        variant="outline-danger" 
                        size="sm" 
                        onClick={() => {
                          setDailyPlans(dailyPlans.filter(p => p.date !== plan.date));
                          toast.info("Plan journalier supprimé", { position: "top-right", autoClose: 2000 });
                        }}
                        className="p-1"
                        title="Supprimer ce plan"
                      >
                        <i className="bi bi-trash" style={{ fontSize: "12px" }}></i>
                      </Button>
                    </div>
                  </div>
                  <div className="small text-muted">
                    {plan.activities.length} activité{plan.activities.length > 1 ? 's' : ''} • {plan.preferences.length} préférence{plan.preferences.length > 1 ? 's' : ''}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="alert text-center my-2 my-md-3 mx-auto p-2 p-md-3" style={{ 
          maxWidth: "90%", 
          backgroundColor: "#f8f9fa", 
          borderLeft: "4px solid #f39c12", 
          color: "#7d6608",
          fontSize: window.innerWidth < 768 ? "0.8rem" : "0.9rem",
          
        }}>
          <i className="bi bi-exclamation-triangle-fill me-1 me-md-2"></i>
          Aucun plan journalier créé. Utilisez le bouton "Ajouter un jour" pour commencer.
        </div>
      )}

      {/* Bouton pour ajouter un nouveau jour */}
      <div className="text-center mb-3">
        <Button
          variant="outline-primary"
          onClick={handleShow}
          className="shadow-sm"
          style={{ width: "80%", borderColor: "#3498db", color: "#3498db" }}
        >
          <i className="bi bi-plus-circle me-2"></i>
          <span className="d-none d-sm-inline">Ajouter un jour</span>
          <span className="d-inline d-sm-none">Ajouter</span>
        </Button>
      </div>
      
      {/* Bouton de génération multi-journalier */}
      <div className="text-center mb-3 mb-md-4">
        <div className="loading-wheel-container d-flex flex-column align-items-center justify-content-center mb-2 mb-md-3">
          <LoadingWheel 
            isLoading={isGenerating} 
            loadingText="Génération du programme multi-journalier..." 
          />
        </div>
        
        <Button
          variant="success"
          onClick={handleGenerateMultiDayPlan}
          className="shadow-sm"
          style={{ width: "80%", backgroundColor: "#27ae60", borderColor: "#229954" }}
          disabled={dailyPlans.length === 0}
        >
          {isGenerating ? (
            <>
              <span className="spinner-border spinner-border-sm me-1 me-md-2" role="status" aria-hidden="true"></span>
              <span className="d-none d-sm-inline">Génération en cours...</span>
              <span className="d-inline d-sm-none">En cours...</span>
            </>
          ) : (
            <>
              <i className="bi bi-lightning-fill me-1 me-md-2"></i>
              <span className="d-none d-sm-inline">Générer le programme</span>
              <span className="d-inline d-sm-none">Générer</span>
            </>
          )}
        </Button>
      </div>
    </Card.Body>
  </Card>
</Col>
            {/* Right part: Activity list (conditional) */}
            {showActivities && (
              <Col lg={3} md={3} sm={12} className="ps-md-3 ps-lg-4" >
                <Card className="shadow-sm mb-4" style={{ backgroundColor: "#ffffff", borderColor: "#dfe4ea", height: window.innerWidth < 768 ? "400px" : "590px" }}>
                  <Card.Header className="py-2 py-md-3" style={{ backgroundColor: "#34495e", color: "white" }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="mb-0 fs-6 fs-md-5">Activités prévues</h5>
                      <span className="badge rounded-pill" style={{ backgroundColor: "#f5f7fa", color: "#34495e" }}>
                        {filteredActivities.length}
                      </span>
                    </div>
                  </Card.Header>
                  
                  <Card.Body className="p-2 p-md-3" style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {filteredActivities.length > 0 ? (
                      <ul className="list-group list-group-flush">
                        {currentItems.map((act, idx) => (
                          <li key={idx} className="list-group-item p-2">
                            <div className="d-flex justify-content-between align-items-start mb-1">
                              <span className="fw-bold" style={{ color: act.preferences ? "#e67e22" : "#3498db" }}>
                                {act.name || act.exercise || (act.preferences ? "Plan alimentaire" : "Activité")}
                              </span>
                              <div className="btn-group btn-group-sm">
                                <Button variant="outline-secondary" size="sm" className="p-1">
                                  <Eye size={14} />
                                </Button>
                                <Button variant="outline-danger" size="sm" className="p-1">
                                  <Trash2 size={14} />
                                </Button>
                              </div>
                            </div>
                            <div className="small">
                              <i className="bi bi-calendar-event me-1" style={{ color: "#7f8c8d" }}></i>
                              {new Date(act.dateTime).toLocaleDateString('fr-FR')}
                              {(act.durationMinutes || act.durer) && (
                                <>
                                  <i className="bi bi-clock ms-2 me-1" style={{ color: "#7f8c8d" }}></i>
                                  {act.durationMinutes || act.durer} min
                                </>
                              )}
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-muted mb-0">Aucune activité trouvée</p>
                      </div>
                    )}
                  </Card.Body>
                  
                  {filteredActivities.length > ITEMS_PER_PAGE && (
                    <Card.Footer className="p-2 text-center">
                      <Pagination size="sm" className="justify-content-center mb-0">
                        <Pagination.Prev 
                          onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
                          disabled={currentPage === 1}
                        />
                        {Array.from({ length: Math.min(totalPages, 3) }).map((_, idx) => {
                          const pageNumber = currentPage === 1 ? idx + 1 :
                                            currentPage === totalPages ? totalPages - 2 + idx :
                                            currentPage - 1 + idx;
                          return pageNumber > 0 && pageNumber <= totalPages ? (
                            <Pagination.Item 
                              key={idx} 
                              active={pageNumber === currentPage}
                              onClick={() => paginate(pageNumber)}
                            >
                              {pageNumber}
                            </Pagination.Item>
                          ) : null;
                        })}
                        <Pagination.Next 
                          onClick={() => paginate(currentPage < totalPages ? currentPage + 1 : totalPages)}
                          disabled={currentPage === totalPages}
                        />
                      </Pagination>
                    </Card.Footer>
                  )}
                </Card>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
  
    



<Modal show={showModal} onHide={handleClose} centered size={isMobile ? "md" : "lg"}>
  <Modal.Header closeButton style={{ 
    backgroundColor: activeTab === "activity" ? "#ebf5fb" : "#fef5e7", 
    borderBottom: activeTab === "activity" ? "2px solid #3498db" : "2px solid #e67e22" 
  }}>
    <Modal.Title style={{ 
      color: activeTab === "activity" ? "#2980b9" : "#d35400",
      display: "flex",
      alignItems: "center",
      fontSize: isMobile ? "1.1rem" : "1.1rem"
    }}>
      {activeTab === "activity" ? (
        <>
          <i className="bi bi-lightning-fill me-2"></i>
          Ajouter une activité
        </>
      ) : (
        <>
          <i className="bi bi-egg-fried me-2"></i>
          Planifier l'alimentation
        </>
      )}
    </Modal.Title>
  </Modal.Header>
  
  <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>

     {/*  Message d'erreur s'il existe */}
  {message && (
    <div className={`alert alert-${message.type}`} role="alert">
      {message.text}
    </div>
  )}
    {/* Sélecteur de date avec protection */}

 

 <div
  className="mb-4 p-3 d-flex justify-content-between align-items-start"
  style={{
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
  }}
>

  <div>
    <Form.Label style={{ color: "#2c3e50", fontWeight: "bold" }}>
      <i className="bi bi-calendar3 me-2"></i>
      Date de planification
    </Form.Label>
    <Form.Control
      type="date"
      value={
        selectedDate && !isNaN(selectedDate.getTime())
          ? selectedDate.toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0]
      }
      onChange={(e) => {
        const newDate = new Date(e.target.value + "T12:00:00");
        if (!isNaN(newDate.getTime())) {
          setSelectedDate(newDate);
        }
      }}
      style={{ borderColor: "#bdc3c7", maxWidth: "200px" }}
    />
    <Form.Text className="text-muted">
      Sélectionnez la date pour laquelle ajouter cette activité/préférence
    </Form.Text>
  </div>

   <div>
      <Form.Check
        type="checkbox"
        id="checkPoids"
        label={
          <span style={{ fontWeight: "bold", color: "#2c3e50" }}>
            📏 Renseigner votre poids actuel
            <span style={{ fontWeight: "normal", color: "#6c757d" }}>
              {" "} (optionnel)
            </span>
          </span>
        }
        checked={showPoids}
        onChange={(e) => setShowPoids(e.target.checked)}
      />

      {showPoids && (
        <>
          <Form.Control
            type="number"
            placeholder="Ex: 72.5 kg"
            value={poids}
            onChange={(e) => setPoids(e.target.value)}
            style={{
              borderColor: "#bdc3c7",
              maxWidth: "200px",
              marginTop: "8px",
              fontWeight: "500",
            }}
          />
          <button
            className="btn btn-primary mt-2"
            onClick={handleSavePoids}
          >
            Enregistrer le poids
          </button>
        </>
      )}
    </div>

</div>





    <Tabs
      activeKey={activeTab}
      onSelect={(key) => setActiveTab(key)}
      className="mb-3"
      style={{ borderBottom: "1px solid #dfe4ea" }}
    >
      <Tab 
        eventKey="activity" 
        title={
          <div className="d-flex align-items-center">
            <i className="bi bi-lightning-fill me-2" style={{ color: "#3498db" }}></i>
            {isMobile ? "Activité" : "Activité Physique"}
          </div>
        }
      >
        <Form>
          <Row className="mb-3">
            <Col md={8} xs={12}>
              <Form.Group className="mb-3">
                <Form.Label style={{ color: "#2c3e50" }}>Type d'activité</Form.Label>
                 <CreatableSelect
      options={activityOptions} // Maintenant ça va fonctionner
      placeholder="Rechercher une activité..."
      noOptionsMessage={() => "Saisie ou selectionne une activité"}
      onInputChange={handleInputChange}
      onChange={(selected) => {
        if (selected) {
          setActivity({
            ...activity,
            exercise: selected.value,        
            exerciseName: selected.label
          });
        }
      }}
      className="text-dark"
      styles={{
        control: (provided) => ({
          ...provided,
          borderColor: "#bdc3c7",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          "&:hover": {
            borderColor: "#3498db"
          }
        })
      }}
    />
                <Form.Text className="text-muted">
                  Recherchez ou sélectionnez une activité dans la liste
                </Form.Text>
              </Form.Group>
            </Col>
            
            <Col md={4} xs={12}>
              <Form.Group>
                <Form.Label style={{ color: "#2c3e50" }}>Durée (minutes)</Form.Label>
                <Form.Control
                  type="number"
                  name="durationMinutes"
                  value={activity.durationMinutes}
                  onChange={handleChange}
                  placeholder="Durée en minutes"
                  min="5"
                  max="300"
                  style={{ borderColor: "#bdc3c7" }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Tab>
      
      <Tab 
        eventKey="meal" 
        title={
          <div className="d-flex align-items-center">
            <i className="bi bi-egg-fried me-2" style={{ color: "#e67e22" }}></i>
            {isMobile ? "Alimentation" : "Préférences Alimentaires"}
          </div>
        }
      >
        <Form>
          <Form.Group className="mb-3">
            <Form.Label style={{ color: "#2c3e50" }}>Préférences alimentaires</Form.Label>
            <CreatableSelect
              options={foodPreferencesOptions}
              isClearable={true}
              isSearchable={true}
              placeholder={isMobile ? "Rechercher..." : "Recherchez ou sélectionnez une préférence alimentaire"}
              isLoading={loadingPreferences}
              noOptionsMessage={() => "Appuyez sur Entrée pour ajouter cette préférence"}
              formatCreateLabel={(inputValue) => `Ajouter "${inputValue}"`}
              onInputChange={handleFoodInputChange}
              onChange={(selected) => {
                if (selected) {
                  setActivity({
                    ...activity,
                    preferences: selected.value
                  });
                }
              }}
              className="text-dark"
              value={foodPreferencesOptions.find(option => option.value === activity.preferences) || 
                    (activity.preferences ? { label: activity.preferences, value: activity.preferences } : null)}
              styles={{
                control: (provided) => ({
                  ...provided,
                  borderColor: "#bdc3c7",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  "&:hover": {
                    borderColor: "#e67e22"
                  }
                })
              }}
            />
            <Form.Text className="text-muted">
              {isMobile ? 
                "Recherchez ou créez une préférence" : 
                "Recherchez, sélectionnez ou créez une préférence alimentaire si elle n'existe pas"}
            </Form.Text>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label style={{ color: "#2c3e50" }}>Intolérances ou allergies</Form.Label>
            <Form.Control
              as="textarea"
              name="intolerances"
              value={activity.intolerances}
              onChange={handleChange}
              placeholder="Ex: Gluten, Lactose, Fruits de mer..."
              rows={isMobile ? 1 : 2}
              style={{ borderColor: "#bdc3c7" }}
            />
          </Form.Group>
        </Form>
      </Tab>
    </Tabs>

    {/* Aperçu des éléments ajoutés pour la date sélectionnée avec onglets */}
    {(() => {
      const currentPlan = getCurrentDayPlan();
      const hasItems = currentPlan.activities.length > 0 || currentPlan.preferences.length > 0;
      
      if (hasItems) {
        return (
          <div className="mt-3 p-3" style={{ 
            backgroundColor: "#ffffff", 
            borderRadius: "8px", 
            border: "1px solid #dee2e6",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
          }}>
            <h6 className="text-center fw-bold border-bottom pb-2 mb-3" style={{ 
              color: "#2c3e50", 
              borderColor: "#dfe4ea",  
              fontSize: isMobile ? "1rem" : "1.1rem"
            }}>
              <i className="bi bi-calendar-check me-2"></i>
              Planifié pour le {selectedDate.toLocaleDateString()}
            </h6>
            
            <Tabs
              defaultActiveKey="physical"
              className="mb-2 nav-justified"
              fill
              style={{ borderBottom: "1px solid #dfe4ea" }}
            >
              <Tab 
                eventKey="physical" 
                title={
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-lightning-fill me-1 me-md-2" style={{ color: "#3498db" }}></i>
                    <span className="d-none d-sm-inline">Activités</span>
                    <span className="d-inline d-sm-none">Act.</span>
                    {currentPlan.activities.length > 0 && (
                      <Badge 
                        bg="primary" 
                        pill 
                        className="ms-1"
                        style={{ backgroundColor: "#3498db" }}
                      >
                        {currentPlan.activities.length}
                      </Badge>
                    )}
                  </div>
                }
              >
                {currentPlan.activities.length > 0 ? (
                  <ul className="list-group list-group-flush">
                    {currentPlan.activities.map((act) => (
                      <li key={act.id} className="list-group-item d-flex justify-content-between align-items-center px-2 py-2">
                        <div>
                          <span className="fw-bold">{act.exerciseName}</span>
                          <span className="ms-2 badge bg-light text-dark">{act.duration} min</span>
                        </div>
                        <Button 
                          variant="outline-danger" 
                          size="sm" 
                          onClick={() => handleRemoveActivity(act.id)}
                          className="p-1"
                        >
                          <i className="bi bi-trash" style={{ fontSize: "14px" }}></i>
                        </Button>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-center text-muted py-3 small">Aucune activité planifiée</p>
                )}
              </Tab>
              
              <Tab 
                eventKey="nutrition" 
                title={
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-egg-fried me-1 me-md-2" style={{ color: "#e67e22" }}></i>
                    <span className="d-none d-sm-inline">Nutrition</span>
                    <span className="d-inline d-sm-none">Nut.</span>
                    {currentPlan.preferences.length > 0 && (
                      <Badge 
                        bg="warning" 
                        pill 
                        className="ms-1"
                        style={{ backgroundColor: "#e67e22" }}
                      >
                        {currentPlan.preferences.length}
                      </Badge>
                    )}
                  </div>
                }
              >
                {currentPlan.preferences.length > 0 ? (
                  <ul className="list-group list-group-flush">
                    {currentPlan.preferences.map((pref) => (
                      <li key={pref.id} className="list-group-item px-2 py-2">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <span className="fw-bold">
                            {pref.type === "ALIMENTARY" ? "Préférence alimentaire" : "Intolérance"}
                          </span>
                          <Button 
                            variant="outline-danger" 
                            size="sm" 
                            onClick={() => handleRemovePreference(pref.id)}
                            className="p-1"
                          >
                            <i className="bi bi-trash" style={{ fontSize: "14px" }}></i>
                          </Button>
                        </div>
                        <div className="small">
                          <span className="fw-medium">{pref.type === "ALIMENTARY" ? "Préférence:" : "Intolérance:"}</span> {pref.name}
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-center text-muted py-3 small">Aucune préférence alimentaire planifiée</p>
                )}
              </Tab>
            </Tabs>
          </div>
        );
      }
      return null;
    })()}
  </Modal.Body>
  
  {/* <Modal.Footer style={{ backgroundColor: "#f8f9fa", borderTop: "1px solid #dfe4ea" }}>
    <Button 
      variant="light" 
      onClick={handleClose}
      style={{ 
        borderColor: "#bdc3c7", 
        color: "#7f8c8d" 
      }}
    >
      Annuler
    </Button>
    <Button 
      variant={activeTab === "activity" ? "primary" : "warning"}
      onClick={handleSubmit}
      disabled={isLoading}
      style={{ 
        backgroundColor: activeTab === "activity" ? "#3498db" : "#e67e22", 
        borderColor: activeTab === "activity" ? "#2980b9" : "#d35400" 
      }}
    >
      {isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {isMobile ? "Ajout..." : "Ajout en cours..."}
        </>
      ) : (
        `Ajouter pour le ${selectedDate.toLocaleDateString()}`
      )}
    </Button>
  </Modal.Footer> */}





  <Modal.Footer style={{ backgroundColor: "#f8f9fa", borderTop: "1px solid #dfe4ea" }}>
  <Button 
    variant="light" 
    onClick={handleClose}
    style={{ 
      borderColor: "#bdc3c7", 
      color: "#7f8c8d" 
    }}
  >
    Annuler
  </Button>
  
  {/* Bouton pour ajouter à la journée courante */}
  <Button 
    variant={activeTab === "activity" ? "outline-primary" : "outline-warning"}
    onClick={handleSubmit}
    disabled={isLoading}
    style={{ 
      borderColor: activeTab === "activity" ? "#3498db" : "#e67e22",
      color: activeTab === "activity" ? "#3498db" : "#e67e22"
    }}
  >
    {isLoading ? (
      <>
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        {isMobile ? "Ajout..." : "Ajout en cours..."}
      </>
    ) : (
      `Ajouter à la journée`
    )}
  </Button>
  
  {/* Bouton pour finaliser le plan de la journée */}
  <Button 
    variant={activeTab === "activity" ? "primary" : "warning"}
    onClick={handleAddDayPlan}
    style={{ 
      backgroundColor: activeTab === "activity" ? "#3498db" : "#e67e22", 
      borderColor: activeTab === "activity" ? "#2980b9" : "#d35400" 
    }}
  >
    Finaliser la journée du {selectedDate.toLocaleDateString()}
  </Button>
</Modal.Footer>
</Modal>

{/* Composant d'aperçu des plans par date - à placer en dehors du modal */}
{dailyPlans.length > 0 && (
  <div className="mt-4 p-4" style={{ 
    backgroundColor: "#ffffff", 
    borderRadius: "12px", 
    border: "1px solid #e9ecef",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)" 
  }}>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 style={{ color: "#2c3e50", margin: 0 }}>
        <i className="bi bi-calendar-week me-2"></i>
        Plan en cours de création
      </h5>
      <Button 
        variant="success" 
        onClick={handleGenerateFullPlan}
        disabled={isGenerating}
        style={{ backgroundColor: "#27ae60", borderColor: "#229954" }}
      >
        {isGenerating ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Génération...
          </>
        ) : (
          <>
            <i className="bi bi-magic me-2"></i>
            Générer le plan complet
          </>
        )}
      </Button>
    </div>
    
    {dailyPlans.map((plan, index) => (
      <div key={index} className="mb-3 p-3" style={{ 
        backgroundColor: "#f8f9fa", 
        borderRadius: "8px",
        border: "1px solid #dee2e6"
      }}>
        <h6 style={{ color: "#495057", marginBottom: "10px" }}>
          <i className="bi bi-calendar3 me-2"></i>
          {new Date(plan.date).toLocaleDateString()}
        </h6>
        
        <div className="row">
          {plan.activities.length > 0 && (
            <div className="col-md-6">
              <small style={{ color: "#6c757d", fontWeight: "bold" }}>Activités ({plan.activities.length})</small>
              {plan.activities.map((act) => (
                <div key={act.id} className="mt-1 p-2" style={{ 
                  backgroundColor: "#d4edda", 
                  borderRadius: "4px",
                  fontSize: "0.85rem"
                }}>
                  {act.name} ({act.duration}min)
                </div>
              ))}
            </div>
          )}
          
          {plan.preferences.length > 0 && (
            <div className="col-md-6">
              <small style={{ color: "#6c757d", fontWeight: "bold" }}>Préférences ({plan.preferences.length})</small>
              {plan.preferences.map((pref) => (
                <div key={pref.id} className="mt-1 p-2" style={{ 
                  backgroundColor: "#fff3cd", 
                  borderRadius: "4px",
                  fontSize: "0.85rem"
                }}>
                  {pref.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
)}



      </Container>

      
  )
          
            }

export default AddActivityModal;





